import React, { useEffect, useState } from "react";
import { Box, Container, Link, Typography } from "@mui/material";
import { palette } from "homepage-new/palette";
import { baseURL } from "../../aws-config";
import api from "../../api";

const WHATSAPP = "https://wa.me/918340156311";
const font = "Be Vietnam Pro";

// Shown once we have a number to call. Deliberately has no action on it — the
// point of asking for the number was so the candidate stops chasing us.
export const CallbackConfirmed = ({ phone }) => {
  const [number, setNumber] = useState(phone || "");

  useEffect(() => {
    if (phone) return;
    // onboarding-data only returns the three booleans, so the number comes
    // from the profile endpoint.
    api
      .get(`${baseURL}user-profile/`)
      .then((res) => setNumber(res?.data?.data?.phone_number || ""))
      .catch(() => setNumber(""));
  }, [phone]);

  return (
    <Container maxWidth="sm">
      <Box sx={{ py: { xs: 6, md: 10 }, textAlign: "center" }}>
        <Typography
          component="h1"
          sx={{
            color: palette.text,
            fontWeight: 700,
            letterSpacing: "-0.03em",
            lineHeight: 1.15,
            fontSize: { xs: 29, md: 38 },
            fontFamily: font,
          }}
        >
          Got it. We'll call you.
        </Typography>

        <Typography
          component="p"
          sx={{
            color: palette.textMuted,
            fontSize: { xs: 16.5, md: 18 },
            lineHeight: 1.68,
            mt: 3,
            fontFamily: font,
          }}
        >
          One of us will ring you{number ? " on " : ""}
          {number && (
            <Box component="span" sx={{ color: palette.text, fontWeight: 600 }}>
              {number}
            </Box>
          )}{" "}
          within one working day, to work out where you are now and what it
          would actually take to get where you're going.
        </Typography>

        <Typography
          component="p"
          sx={{
            color: palette.textMuted,
            fontSize: { xs: 16.5, md: 18 },
            lineHeight: 1.68,
            mt: 2.5,
            fontFamily: font,
          }}
        >
          Half an hour, no cost, no card. Nothing else for you to do.
        </Typography>

        <Box sx={{ mt: 5, pt: 3.5, borderTop: `1px solid ${palette.border}` }}>
          <Typography
            component="p"
            sx={{ color: palette.textFaint, fontSize: 14.5, fontFamily: font }}
          >
            In a hurry?{" "}
            <Link
              href={WHATSAPP}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: palette.primary }}
            >
              Message us on WhatsApp
            </Link>
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default CallbackConfirmed;
